import React from "react";
import { Typography, Grid, Box } from "@mui/material";
import { useResponsive } from "../../hooks/use-responsive";

export default function HeroSix() {

  const mdUp = useResponsive("up", "md");

  return (

    <Grid
      container
      spacing={3}
      sx={{ justifyContent: "center", alignContent: "center" }}
    >
      {mdUp && (
        <Grid item xs={12} md={6}>
          <Typography
            component="span"
            className="HeroHeading"
          >
            PROTECT YOUR CHILD FROM &nbsp;<span className="HeroHighlighted"  >ONLINE THREATS!</span>
          </Typography>

          <Box justifyContent='center' alignItems='center' mt='28px' >
            <Typography className="heroText" >
              With MegaConnect cloud pc, you gain full control over their cloud PC, ensuring they stay secure and protected online.
            </Typography>
          </Box>

        </Grid>
      )}
      {mdUp && <Grid item xs={12} md={6}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/assets/home_hero_six.svg"
            alt="home_hero_six"
            style={{ maxWidth: "100%", height: 'auto', objectFit: 'fill' }}

          />
        </Box>
      </Grid>}
      {!mdUp && <Grid item xs={12} md={6}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/assets/home_hero_six_sm.svg"
            alt="home_hero_six"
            style={{ maxWidth: "100%", height: 'auto', objectFit: 'fill' }}

          />
        </Box>
      </Grid>}
      {!mdUp && (
        <Grid item xs={12} md={7} textAlign="center" >
          <Typography
            component="span"
            className="HeroHeading"
            textAlign={'center'}
          >
            PROTECT YOUR CHILD FROM &nbsp;<span className="HeroHighlighted"  >ONLINE THREATS!</span>
          </Typography>

          <Box sx={{
            // mt: '18px',
            minHeight: '106px', // Set a minimum height for the Box
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}   >
            <Typography textAlign='center' className="heroText"
            >
              With MegaConnect cloud pc, you gain full control over their cloud PC, ensuring they stay secure and protected online.
            </Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  )
}
